import dayjs from "dayjs";
import { processDateJS } from "./dateProcessor";

function formatTimestamp(timestamp) {
  const date = new Date(timestamp._seconds * 1000); // Convert seconds to milliseconds
  return dayjs(date).format("DD/MM/YYYY HH:mm:ss"); // Format using dayjs
}

export function exportWBSLogs(data, workbook) {
  const sheet = workbook?.addWorksheet("WBS logs");
  const headerRow = sheet.addRow([
    "Group Name",
    "Is Group Deleted?",
    "WBS code",
    "Charge type",
    "Incremental charge",
    "Number of OneSource companies",
    "Number of UK companies",
    "PoA Start",
    "PoA End",
    "Is PoA Deleted?",
    "Return Type",
    "timestamp",
  ]);

  sheet.getColumn(6).alignment = { horizontal: "right" };

  headerRow.eachCell((cell) => {
    cell.alignment = {
      wrapText: true,
      vertical: "middle",
      horizontal: "center",
    };
    cell.font = { bold: true };
  });

  sheet.autoFilter = {
    from: "A1",
    to: "L1",
  };

  data.sort((a, b) => b.timestamp._seconds - a.timestamp._seconds);

  for (let entry of data) {
    const { charge_type, is_group_deleted, is_poa_deleted } = entry;
    let row = [
      entry.group_name,
      is_group_deleted ? "Yes" : "No",
      entry.wbs_code,
      charge_type,
      entry.incremental_charge,
      charge_type === "fixed" ? "-" : entry.number_of_onesource_companies,
      entry.number_of_uk_companies,
      processDateJS(entry.poa_start).format("DD/MM/YYYY"),
      processDateJS(entry.poa_end).format("DD/MM/YYYY"),
      is_poa_deleted || is_group_deleted ? "Yes" : "No",
      entry.return_type,
      formatTimestamp(entry.timestamp),
    ];
    sheet.addRow(row);
  }

  const widths = [50, 15, 15, 15, 17, 17, 17, 14, 14, 14, 14, 18];
  for (let i = 0; i < 12; i++) {
    sheet.getColumn(i + 1).width = widths[i];
  }

  return workbook;
}

export function exportWBSLogsFullReport(data, workbook) {
  const sheet = workbook?.addWorksheet("Full Report");
  const headerRow = sheet.addRow([
    "Group Name",
    "WBS Code",
    "First period start",
    "First period end",
    "return isFinalised",
    "return isRevised",
    "return isSubmitted",
    "return type",
    "withoutReportingCompany",
    "UK Group Companies",
    "Companies from Onesource",
    "Accounting periods from_onesource",
  ]);

  headerRow.eachCell((cell) => {
    cell.alignment = {
      wrapText: true,
      vertical: "middle",
      horizontal: "center",
    };
    cell.font = { bold: true };
  });

  sheet.autoFilter = {
    from: "A1",
    to: "J1",
  };

  for (let group of data) {
    const groupData = group?.data;
    let row = [];

    const firstPeriod = groupData?.periods_of_account?.[0] ?? {
      period_start: "",
      period_end: "",
      return_status: {
        isFinalised: "",
        isRevised: "",
        isSubmitted: "",
      },
    };

    row = [
      group?.id,
      groupData?.wbsCode,
      firstPeriod?.period_start &&
        processDateJS(firstPeriod.period_start)?.format("DD/MM/YYYY"),
      firstPeriod?.period_end &&
        processDateJS(firstPeriod.period_end)?.format("DD/MM/YYYY"),
      firstPeriod?.return_status?.isFinalised,
      firstPeriod?.return_status?.isRevised,
      firstPeriod?.return_status?.isSubmitted,
      firstPeriod?.return_status?.type,
      firstPeriod?.return_status?.withoutReportingCompany,
      groupData?.companies?.filter((c) => c.uk_group_company).length,
      groupData?.companies?.filter((c) => c.from_onesource).length,
      groupData?.company_accounting_periods?.filter(
        (period) => period.from_onesource,
      )?.length,
    ];

    sheet.addRow(row);

    (groupData?.periods_of_account &&
    Array.isArray(groupData.periods_of_account)
      ? groupData.periods_of_account.slice(1)
      : []
    ).forEach((period) => {
      sheet.addRow([
        group?.id,
        groupData?.wbsCode,
        period?.period_start &&
          processDateJS(period.period_start)?.format("DD/MM/YYYY"),
        period?.period_end &&
          processDateJS(period.period_end)?.format("DD/MM/YYYY"),
        period?.return_status.isFinalised,
        period?.return_status.isRevised,
        period?.return_status.isSubmitted,
        period?.return_status.type,
        period?.return_status.withoutReportingCompany,
        "",
        "",
        "",
      ]);
    });
  }

  sheet.getColumn(1).width = 50;
  sheet.getCell("A1").font = { bold: true };

  sheet.getColumn(2).width = 12;
  sheet.getCell("B1").font = { bold: true };

  sheet.getColumn(3).width = 12;
  sheet.getCell("C1").font = { bold: true };

  sheet.getColumn(4).width = 12;
  sheet.getCell("D1").font = { bold: true };

  sheet.getColumn(5).width = 12;
  sheet.getCell("E1").font = { bold: true };

  sheet.getColumn(6).width = 12;
  sheet.getCell("F1").font = { bold: true };

  sheet.getColumn(7).width = 12;
  sheet.getCell("G1").font = { bold: true };

  sheet.getColumn(8).width = 12;
  sheet.getCell("H1").font = { bold: true };

  sheet.getColumn(9).width = 12;
  sheet.getCell("I1").font = { bold: true };

  sheet.getColumn(10).width = 18;
  sheet.getCell("J1").font = { bold: true };

  return workbook;
}
